import React from 'react';
import { Container, Row, Col } from 'reactstrap';

export const FlightExpired: React.FC = () => {
    return (
        <Container>
            <Row>
                <Col xs="12" style={{ textAlign:"center", margin:"40px"}}>
                    <h2>Tracking information is no longer available for this flight.</h2>
                </Col>
            </Row>
        </Container>
    );
}